export const SUCCESS_STORIES_HEADING = 'Success stories';
export const SUCCESS_STORIES_BUTTON_TEXT = 'Contact Us';
